import Container from '@mui/material/Container';
import { jsx } from 'react/jsx-runtime';

// src/listen/minimalism/home/main-container.tsx
var MainContainer = (props) => {
  return /* @__PURE__ */ jsx(Container, { maxWidth: "xl", component: "main", children: props.children });
};

export { MainContainer };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XICLDU4V.mjs.map